import { api } from "..";

export interface BulkLockAgentsBettingRulesPayload {
  ids: number[];
  locked: boolean;
}

export async function bulkLockAgentsBettingRules(
  payload: BulkLockAgentsBettingRulesPayload
): Promise<{ success: boolean; updatedCount: number }> {
  const res = await api.client.post(
    `/agents-new/bulk-betting-rules-lock`,
    payload
  );
  return res.data;
}
